import { getAssociationAnalyticsBigSpenders } from 'legacy/groups/service';
import { useQuery } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { OutgoingGroupAnalyticsSegmentDto } from 'api/dtos/analytics';
import {
  AnalyticsQueryConfig,
  getAnalyticsQueryOptions,
  applyDisplayCountLimit
} from 'screens/organizations/components/OrganizationAnalytics/components/TopN/hooks/useAnalyticsQueryUtils';

export function useAssociationAnalyticsBigSpenders(
  associationId: string,
  displayCount = 5
) {
  const queryConfig: AnalyticsQueryConfig = {
    displayCount
  };

  const result = useQuery<OutgoingGroupAnalyticsSegmentDto, ErrorResponse>(
    ['association-analytics-big-spenders', { associationId }],
    () => getAssociationAnalyticsBigSpenders({ associationId, limit: 100 }),
    getAnalyticsQueryOptions(queryConfig)
  );

  return applyDisplayCountLimit(result, displayCount);
}
